import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../../Service/axiosInstance";
import { Button } from '@mui/material';

function Offres() {
    const navigate = useNavigate();
    const [packages, setPackages] = useState([]);
    const [typeOffre, setTypeOffre] = useState([]);

    useEffect(() => { 
      axiosInstance
        .get("/yourtravelshop/package/liste")
        .then((response) => {
          setPackages(response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des packages :", error);
        });
    }, []);
    useEffect(() => { 
      axiosInstance
        .get("/yourtravelshop/typeOffre/liste")
        .then((response) => {
          setTypeOffre(response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des packages :", error);
        });
    }, []);
    

    return (
        <div>
        <div className="home">
        <div 
          className="home_background"
          style={{ 
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/vu.jpeg)`, 
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="home_content">
            <div className="home_title">Nos Offres</div>
            </div>
        </div>
        </div>

      <div className="offers"   >
        <div className="container">
        <div
  style={{
    marginTop: "-70px",
    display: "flex",
    flexWrap: "wrap", // permet de passer à la ligne si trop long
    gap: "10px" // espace entre les boutons
  }}
>
  {typeOffre.length > 0 ? (
    typeOffre.map((offre) => (
      <button
        key={offre.id}
        onClick={() => navigate(`/type-offres/${offre.id}`)}
        style={{
          backgroundColor: "#444",
          color: "white",
          border: "1px solid #666",
          borderRadius: "5px",
          padding: "6px 12px",
          textAlign: "center",
          cursor: "pointer",
          transition: "background-color 0.3s, text-decoration 0.2s"
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#555";
          e.target.style.textDecoration = "underline";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "#444";
          e.target.style.textDecoration = "none";
        }}
      >
        {offre.nom}
      </button>
    ))
  ) : (
    <p style={{ color: "white" }}>Aucune offre disponible</p>
  )}
</div>

          <div className="row offers_items">
            {packages.map((pkg) => (
              <div className="col-lg-6 offers_col" key={pkg.idPackage}>
                <div className="offers_item">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="offers_image_container">
                        <div
                          className="offers_image_background"
                          style={{
                            backgroundImage: pkg.prospectusPhoto
                              ? `url(${pkg.prospectusPhoto.stockage})`
                              : "url('default-image.jpg')", // Default image
                          }}
                        />
                        <div className="offer_name" style={{ width: 'fit-content'}}>
  			<a href="#">{pkg.nom}</a>
			</div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="offers_content">
                        <div className="offers_price">
                          {pkg.prix} <span> Ariary</span>
                        </div>
                        <div className="rating_r rating_r_4 offers_rating">
                          <i />
                          <i />
                          <i />
                          <i />
                          <i />
                        </div>
                        <p className="offers_text">
                          {pkg.description}
                        </p>
                        <div className="button button_1 offers_button">
                          <Button
                            variant="contained"
                            onClick={() => navigate(`/Package-details/${pkg.idPackage}`)}
                            style={{
                              backgroundColor: '#8a2be2',  // Violet
                              color: 'white',              // White text
                              fontWeight: 'bold',          // Bold text
                              padding: '10px 20px',        // Padding
                              borderRadius: '15px',        // Rounded corners
                            }}
                          >
                            Voir Détails
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    );
}

export default Offres;
